import {Button, Modal} from "react-bootstrap";

const ConfirmModal = ({ show, handleClose, handleConfirm, title, message }) => {
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{message}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Nē
                </Button>
                <Button variant="primary" onClick={handleConfirm}>
                    Jā
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmModal;
